// extracted by mini-css-extract-plugin
export default {"button":"TenantButton_button__O87BZ","location_bg":"TenantButton_location_bg__tE1m9","navi_bg":"TenantButton_navi_bg__-hsqq"};